// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__vCXw1","requiredAsterisk":"Info_requiredAsterisk__20bh6"};